export default __webpack_public_path__ + "static/media/packet2.64c3d06a.png";